<template>
  <v-container fluid>
    <PageWrapper :is-loading="preloader">
      <template #title>Статистика
        <div class="help_symbol ml-2"  @click="isAlertOpen = true">?</div>
      </template>
      <template #actions>

        <v-menu offset-y max-height="200" v-model="isMenuOpen">
          <v-btn slot="activator" outline class="summary-years" style="border-radius: 5px">
            {{year}}
            <v-icon>{{ isMenuOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile v-for="(year, index) in years" :key="index" @click="update(year)">
              <v-list-tile-title>{{ year }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-btn class="ml-0 sm-ml-2 " depressed color="blue" @click="detailDataDialog = !detailDataDialog" dark>
          <v-progress-circular v-if="reportPreloader" indeterminate :size="20" color="white"></v-progress-circular>
          {{!reportPreloader ? "Отчет" : ""}}
        </v-btn>
      </template>

      <v-divider></v-divider>

      <div class="flight-statistic-block pa-3">
        <div class="">
          <div v-for="row in leftItems" :key="row.FieldName" class="summary-list align-center py-1">
            <div>{{row.Unit ? `${row.FieldName}, ${row.Unit}` : row.FieldName}}</div>
            <div class="summary-text-rigth font-weight-bold black--text">{{row.Count | currency('', 0, { thousandsSeparator: ' ', spaceBetweenAmountAndSymbol: true, symbolOnLeft: false })}}</div>
            <div> ({{row.CountArrival| currency('', 0, { thousandsSeparator: ' ', spaceBetweenAmountAndSymbol: false, symbolOnLeft: false })}} /
              {{row.CountDeparture | currency('', 0, { thousandsSeparator: ' ', spaceBetweenAmountAndSymbol: false, symbolOnLeft: false })}})
            </div>
            <div class="d-flex align-center">
              <span
                :class="getGrowthClass(row)"
                class="font-weight-bold summary-text-rigth mr-1"
              >{{getGrowth(row)}}</span>
              <v-icon
                :title="parseInt(row.PrevCount) === 0 ? 'Нет данных для сравнения' : 'По отношению к аналогичному периоду прошлого года'"
                medium
                :class="getClass(row)"
              >{{ getIcon(row) }}</v-icon>
            </div>
          </div>
        </div>

        <div class="">
          <div v-for="(row, id) in rightItems" :key="row.FieldName" class="summary-list align-center py-1">
            <div>{{row.FieldName}}</div>
            <div class="summary-text-rigth font-weight-bold black--text">{{row.Count | currency('', 0, { thousandsSeparator: ' ', spaceBetweenAmountAndSymbol: true, symbolOnLeft: false })}}</div>
            <div>
              <div v-if="id === 0">
                ({{row.CountArrival| currency('', 0, { thousandsSeparator: ' ', spaceBetweenAmountAndSymbol: false, symbolOnLeft: false })}} /
                {{row.CountDeparture | currency('', 0, { thousandsSeparator: ' ', spaceBetweenAmountAndSymbol: false, symbolOnLeft: false })}})
              </div>
            </div>
            <div class="d-flex align-center">
              <span
                :class="getGrowthClass(row)"
                class="font-weight-bold summary-text-rigth mr-1"
              >{{getGrowth(row)}}</span>
              <v-icon
                :title="parseInt(row.PrevCount) === 0 ? 'Нет данных для сравнения' : 'По отношению к аналогичному периоду прошлого года'"
                medium
                :class="getClass(row)"
              >{{ getIcon(row) }}</v-icon>
            </div>
          </div>
        </div>
      </div>


      <TableWrapper height="280px">
        <v-data-table
          :headers="monthTable"
          :expand="expand"

          :items="((this.summary.hasOwnProperty(this.year)) ? this.summary[this.year].byMonth : [])"
          hide-actions
          disable-initial-sort
          no-data-text="Нет данных"
          item-key="Month"
          class="elevation-0 small-table"
          ref='table'
        >
          <template v-slot:items="props">
            <tr @click="props.expanded = !props.expanded">
              <td>{{ getMonthName(props.item.Month) }}</td>
              <td
                class="summary-table-top pt-1"
                v-for="(col, index) in monthTable"
                v-if="!(col.value === 'Month')"
                :key="'td-'+index"
              >
                  <div v-if="index <= 4" title="вылет/прилет" class="whitespace-nowrap">
                    <div class="font-weight-bold">
                      {{ props.item[col.value] | currency('', 0, { thousandsSeparator: ' ', spaceBetweenAmountAndSymbol: true, symbolOnLeft: false }) }}
                    </div>
                    <div style="color: #5F6368">
                      ({{ props.item[col.valueArrival] | currency('', 0, { thousandsSeparator: ' ', spaceBetweenAmountAndSymbol: false, symbolOnLeft: false }) }} /
                      {{ props.item[col.valueDeparture] | currency('', 0, { thousandsSeparator: ' ', spaceBetweenAmountAndSymbol: false, symbolOnLeft: false }) }})
                    </div>
                  </div>
                <span v-if="index > 4"  class="whitespace-nowrap font-weight-bold">
                    {{ props.item[col.value] | currency('', 0, { thousandsSeparator: ' ', spaceBetweenAmountAndSymbol: true, symbolOnLeft: false }) }}
                  </span>
              </td>
            </tr>
          </template>
          <template slot="footer">
            <td>
              <b>ИТОГО</b>
            </td>
            <td
              v-for="(col, index) in ((this.summary.hasOwnProperty(this.year)) ? total : [])"
              :key="'sum-'+index"
            >
              <div v-if="index <= 3" title="вылет/прилет"  class="whitespace-nowrap">
                <div class="font-weight-bold">
                  {{ col.Count | currency('', 0, { thousandsSeparator: ' ', spaceBetweenAmountAndSymbol: true, symbolOnLeft: false }) }}
                </div>
                <div style="color: #5F6368">
                  ({{ col.CountArrival| currency('', 0, { thousandsSeparator: ' ', spaceBetweenAmountAndSymbol: false, symbolOnLeft: false }) }} /
                  {{ col.CountDeparture| currency('', 0, { thousandsSeparator: ' ', spaceBetweenAmountAndSymbol: false, symbolOnLeft: false }) }})
                </div>
              </div>
              <span v-if="index >= 4"  class="whitespace-nowrap font-weight-bold">
                {{ col.Count | currency('', 0, { thousandsSeparator: ' ', spaceBetweenAmountAndSymbol: true, symbolOnLeft: false }) }}
              </span>
            </td>
          </template>
        </v-data-table>
      </TableWrapper>
    </PageWrapper>
    <v-dialog
      v-model="detailDataDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="detailDataDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Формирование отчета</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              class="elevation-0"
              dark
              color="primary"
              :loading="reportPreloader"
              @click="getReportFile"
            >Word</v-btn>
            <v-btn
              class="elevation-0"
              :loading="reportPreloader"
              @click="getXLSReportFile"
              dark
              color="primary"
            >Excel</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-layout row class="report-settings-wrap">
            <r-calendar v-model="filterDateFrom" type="month" placeholder="Период С"></r-calendar>
            <r-calendar v-model="filterDateTo" type="month" placeholder="Период По"></r-calendar>
            <v-autocomplete
              v-model="selectedAP"
              :items="filterAP"
              item-text="NAME_AP"
              item-value="IATA"
              label="Аэропорт"
              multiple
            >
              <template v-slot:selection="data">
                <span class="filter-item-iata" v-if="data.item.IATA">{{data.item.IATA}}</span>
              </template>
            </v-autocomplete>
            <v-autocomplete
              v-model="selectedOK"
              :items="filterOK"
              item-text="nm"
              item-value="id_OK"
              label="Авиакомпания"
              multiple
            >
              <template v-slot:selection="data">
                <span class="filter-item-iata" v-if="data.item.IATA">{{data.item.IATA}}</span>
              </template>
            </v-autocomplete>
            <v-btn color="blue" dark depressed @click="getReportPreview()">Просмотр</v-btn>
          </v-layout>
          <div class="text-xs-center" v-show="reportPreviewLoader">
            <div class="m-20"></div>
            <v-progress-circular indeterminate :size="50" color="primary"></v-progress-circular>
            <div class="m-20"></div>
          </div>
          <v-layout>
            <report-preview
              v-show="!reportPreviewLoader"
              :report="reportPreview"
              :headers="reportPreviewHeaders"
            ></report-preview>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isAlertOpen" width="660">
      <v-card>
        <div class="title modal-top mb-0 pa-3">
          Общий пассажиропоток аэропорта за год: учитываются абсолютно все прибывшие/убывшие пассажиры
          <v-icon class="modal-top-close" @click="isAlertOpen = false">close</v-icon>
        </div>
        <v-divider/>
        <v-card-text class=''>
          Статистика отображает данные по количеству рейсов, пассажиров, багаже, почте, грузов и трансферам. <br><br>
          Количество рейсов разбитое на прилет и вылет не учитывает домашние рейсы (облета). <br><br>
          В конструкторе отчетов аналогичную статистику можно получить просуммировав транзитных пассажиров, трансферов (в том числе Рм), сделав выборку рейсов "по взлету и посадке" за выбранные даты.
        </v-card-text>
        <v-divider/>
        <div class="modal-bottom pa-3">
          <v-btn color="primary" class="ma-0" @click="isAlertOpen = false">ЗАКРЫТЬ</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import store from '@/store'
import summaryStat from '@/components/SummaryStat'
import reportPreview from '@/components/reportPreview'
import rCalendar from '@/components/Calendar'
import PageWrapper from "../ui/PageWrapper.vue";
import TableWrapper from "../ui/TableWrapper.vue";
export default {
  data() {
    return {
      isMenuOpen: false,
      /** Filters */
      filterDateFrom: new Date().toISOString().substr(0, 7),
      filterDateTo: new Date().toISOString().substr(0, 7),
      filterOK: [],
      filterAP: [],
      selectedAP: [],
      selectedOK: [],
      /** Preview */
      reportPreviewLoader: false,
      reportPreview: {},
      reportPreviewHeaders: [
        {
          name: 'AK_NAME',
          title: 'Авиакомпания',
          class: 'croped',
        },
        {
          name: 'MONTH',
          title: 'Месяц',
          callback: v => this.getMonthName(v),
        },
        {
          name: 'CNTFL',
          title: 'Рейсов выполнено',
          class: 'text-xs-center',
        },
        {
          name: 'MRSH',
          title: 'Направление',
          class: 'text-xs-center',
        },
        {
          name: 'TS',
          title: 'Тип ВС',
          class: 'text-xs-center',
        },
        {
          name: 'PAX',
          title: 'Пассажиров',
          class: 'text-xs-center',
        },
        {
          name: 'LOAD',
          title: 'Загрузка',
          class: 'text-xs-center',
        },
      ],
      /** Data */
      detailDataDialog: false,
      limit: 3,
      expand: false,
      directionTab: 'tab-arrival',
      curYear: new Date().getFullYear(),
      monthTable: [
        {
          text: 'Месяц',
          align: 'left',
          sortable: false,
          value: 'Month',
        },
        { text: 'Рейсы', value: 'CurrFlights', valueArrival: 'CurrFlightsArrival', valueDeparture: 'CurrFlightsDeparture'},
        { text: 'Пассажиры', value: 'CurrPax', valueArrival: 'CurrPaxArrival', valueDeparture: 'CurrPaxDeparture', tooltip: 'Всего, включая тразитных (прилет) и трансферных, в том числе Рм, по каждому пункту'},
        { text: 'Багаж', value: 'CurrBaggage', valueArrival: 'CurrBaggageArrival', valueDeparture: 'CurrBaggageDeparture',tooltip: 'Всего, включая транзитный и платный багаж'},
        { text: 'Платный багаж', value: 'CurrBaggagePaid', valueArrival: 'CurrBaggagePaidArrival', valueDeparture: 'CurrBaggagePaidDeparture'},
        { text: 'Почта', value: 'CurrMail' },
        { text: 'Груз', value: 'CurrCargo' },
        { text: 'Трансферные п-ры', value: 'CurrTransferPax', tooltip: 'Включая Рм' },
        { text: 'Транзитные п-ры', value: 'CurrTransPax', tooltip: 'Включая Рм' },
      ],
      isAlertOpen: false,
    }
  },
  components: {
    TableWrapper,
    PageWrapper,
    summaryStat,
    reportPreview,
    'r-calendar': rCalendar,
  },
  computed: {
    years: function() {
      let d = new Date('2010')
      let first = d.getFullYear()
      let s = new Date()
      let second = s.getFullYear()
      let arr = []
      for (let i = second; i >= first; i--) arr.push(i)
      return arr
    },
    preloader: {
      get() {
        return store.getters['summary/getPreloader']
      },
      set(value) {
        store.commit('summary/setPreloaderState', value)
      },
    },
    reportPreloader: {
      get() {
        return store.getters['summary/getReportPreloader']
      },
      set(value) {
        store.commit('summary/setReportPreloaderState', value)
      },
    },
    summary: {
      get() {
        return JSON.parse(JSON.stringify(store.getters['summary/getSummary']))
      },
      set(data) {
        store.commit('summary/setSummaryData', { data: data.value, year: data.year })
      },
    },
    reportMonths: {
      get() {
        return store.getters['summary/getReportMonths']
      },
    },
    year: {
      get() {
        return store.getters['summary/getYear']
      },
      set(value) {
        store.commit('summary/setYear', value)
      },
    },
    label: function() {
      if (this.summary === 'undefined') return { text: 'Загрузка', color: 'primary' }
      let perSum = 0
      let label = {}
      for (let i = 0; i < this.limit; i++) {
        if (this.summary[i]) perSum += this.summary[i].Growth
      }
      label.text = perSum > 0 ? 'Рост' : 'Снижение'
      label.color = perSum > 0 ? 'green' : 'red'
      return label
    },
    byMonth: function() {
      return this.summary.hasOwnProperty(this.year) ? this.summary[this.year].byMonth : []
      // return this.summary[this.year].byMonth || []
    },
    total() {
      return this.monthTable.reduce((acc, e) => {
        const item = this.summary[this.year].common.find(item => e.text === item.FieldName)
        if (item) acc.push(item)
        return acc
      }, [])
    },
    leftItems() {

      const fields = ['Рейсы', 'Багаж', 'Платный багаж', 'Груз', 'Почта']
      return fields.reduce((acc, e) => {
        if (!this.summary[this.year]) {
          return acc
        }
        acc.push(this.summary[this.year].common.find(item =>
          e === item.FieldName
        ))
        return acc
      }, [])
    },
    rightItems() {
      const fields = ['Пассажиры', 'Трансферные п-ры', 'Транзитные п-ры']
      return fields.reduce((acc, e) => {
        if (!this.summary[this.year]) {
          return acc
        }
        acc.push(this.summary[this.year].common.find(item =>
          e === item.FieldName
        ))
        return acc
      }, [])
    }
  },
  methods: {
    getGrowth(row) {
      if (parseInt(row.PrevCount) === 0) {
        return '-'
      }
      return parseInt(row.PrevCount) > 0
        ? `+${row.Growth}%`
        : `-${row.Growth}%`
    },
    getGrowthClass(row) {
      if (parseInt(row.PrevCount) === 0) {
        return 'mr-4'
      }
      return row.Growth > 0 ? 'green--text' : 'red--text'
    },
    getClass(row) {
      if (parseInt(row.PrevCount) === 0) {
        return 'orange--text'
      }
      return row.Growth > 0 ? 'green--text' : 'red--text'
    },
    getIcon(row) {
      if (parseInt(row.PrevCount) === 0) {
        return 'history'
      }
      return row.Growth > 0 ? 'arrow_upward' : 'arrow_downward'
    },
    getReportFile() {
      const params = {
        dateFrom: this.filterDateFrom + '-01',
        dateTo: this.filterDateTo + '-01',
      }
      if (this.selectedAP.length) params.AP = this.selectedAP
      if (this.selectedOK.length) params.OK = this.selectedOK
      params.type = 'docx'
      store.dispatch('summary/getReportFile', params)
    },
    getXLSReportFile() {
      const params = {
        dateFrom: this.filterDateFrom + '-01',
        dateTo: this.filterDateTo + '-01',
      }
      if (this.selectedAP.length) params.AP = this.selectedAP
      if (this.selectedOK.length) params.OK = this.selectedOK
      params.type = 'xls'
      store.dispatch('summary/getReportFile', params)
    },
    getReportPreview() {
      const params = {
        dateFrom: this.filterDateFrom + '-01',
        dateTo: this.filterDateTo + '-01',
      }
      if (this.selectedAP.length) params.AP = this.selectedAP
      if (this.selectedOK.length) params.OK = this.selectedOK
      this.reportPreviewLoader = true
      store
        .dispatch('summary/getReportPreview', params)
        .then(result => {
          this.reportPreviewLoader = false
          this.reportPreview = result
        })
        .catch(error => {
          this.reportPreviewLoader = false
          console.log(error)
        })
    },
    update: function(year) {
      this.year = year
      store.dispatch('summary/updateSummary')
    },
    getMonthName: function(month) {
      let months = [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
      ]
      return months[--month]
    },
    setTableHeaderTooltip() {
      const nodes = this.$refs.table.$children || []
      if (nodes.length === 0) return
      this.monthTable.forEach((e, id) => {
        if (!e.tooltip) return
        nodes[id === 0 ? 0 : id - 1].$el.parentNode.title = e.tooltip
      })
    },
  },
  mounted: function() {
    store.commit('setPageTitle', 'Статистика')
    store.dispatch('summary/getReportMonths')
    store
      .dispatch('summary/getReportFilters')
      .then(result => {
        this.filterOK = result.OK || []
        this.filterAP = result.AP || []
      })
      .catch(err => {
        console.log(err)
      })
    this.setTableHeaderTooltip()
  },
}
</script>
<style lang="stylus" scoped>

.filter-item-iata {
  border: dashed 1px #2196f3;
  font-size: smaller;
  padding: 0px 2px;
  margin-right: 4px;
}

.filter-item-iata:last-child {
  margin: 0;
}


.flight-statistic-block {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  overflow-x: auto;
}
@media (max-width: 968px) {
  .flight-statistic-block {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 769px) {
  .report-settings-wrap {
    display: block;
  }
}
.modal-top {
  color: #424445;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: start;
  font-size: 16px;
}
.modal-top-close {
  color: #424445 !important;
  margin-left: 1px;
  cursor: pointer;
}
.modal-bottom {
  display: flex;
  justify-content: end;
}

.help_symbol {
  width: 20px;
  height: 20px;
  border: 2px solid #D9D9D9;
  border-radius: 100%;
  font-size: 12px !important;
  background-color: #EEEEEE;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.summary-years {
  border: 1px solid #8AA1AC;
  border-radius: 5px;
  color: #232323;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.summary-list {
  display: grid;
  grid-template-columns: 1fr 100px 142px 100px;
  gap: 10px;
  font-size: 12px;
  line-height: 16px;
  color: #5F6368;
  &:not(&:last-child) {
    border-bottom: 1px solid #D9D9D9;
  }
  i {
    font-size: 16px !important;
    max-width: 16px;
  }
}
.summary-text-rigth {
  text-align: right
}
.summary-table-top {
  vertical-align: top;
}
</style>
